import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { LanguageCode, getLocaleCode } from '../../Translator'
import Cookies from 'js-cookie'
import moment from 'moment'
import { setDefaultLocale } from 'react-datepicker';


const languageSlice = createSlice({
    name: 'SLICE_language',
    initialState: 'NL' as LanguageCode,
    reducers: {
    languageChanged(state, action:  PayloadAction<LanguageCode>) {
            const newLanguage = action.payload;
            const locale = getLocaleCode(newLanguage);
            Cookies.set('.AspNetCore.Culture', `c=${locale}|uic=${locale}`, { expires: 365, sameSite: 'Lax', secure: true }); //TODO: wegmaken; violates side-effect-free redux requirement
            document.documentElement!.lang = locale; //TODO: nog een side-effect die hier niet hoort
            moment.locale(locale);//TODO: nog een side-effect die hier niet hoort
            setDefaultLocale(locale);//TODO: nog een side-effect die hier niet hoort
            return newLanguage;
        }
    },
})

export const { languageChanged } = languageSlice.actions

export default languageSlice.reducer
